// 2023 Topps Star Wars Chrome — first flagship Chrome release.
// Transcribed from the official Topps checklist PDF; parallel structure
// verified across Cardboard Connection + Cardsmiths (base has no /10 tier;
// Chrome Autographs exist only as numbered refractors, Blue /150 and down).

// Base parallels — Black/Purple Wave are retail (blaster) exclusives.
const BASE_P = [
  { id: 'refractor', name: 'Refractor', color: '#c8d8f0' },
  { id: 'black-wave', name: 'Black Wave Refractor', color: '#5a5a6a' },
  { id: 'purple-wave', name: 'Purple Wave Refractor', color: '#b060ff' },
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#616161' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Shared insert parallels (all five insert lines).
const INS_P = [
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Chrome Autographs — no unnumbered base version; every copy is a numbered refractor.
const AUTO_P = [
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black', name: 'Black Refractor', print_run: 10, color: '#5a5a6a' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// First Appearance autographs + dual/triple autographs: Red /5 + Superfractor only.
const RED_SUPER_P = [
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS', parallels: BASE_P,
    cards: [
      {n:'1', name:'Cassian Andor', artist:'Diego Luna'},
      {n:'2', name:'Mon Mothma', artist:'Genevieve O\'Reilly'},
      {n:'3', name:'K-2SO', artist:'Alan Tudyk'},
      {n:'4', name:'Saw Gerrera', artist:'Forest Whitaker'},
      {n:'5', name:'Luthen Rael', artist:'Stellan Skarsgård'},
      {n:'6', name:'Obi-Wan Kenobi', artist:'Ewan McGregor'},
      {n:'7', name:'Reva', artist:'Moses Ingram'},
      {n:'8', name:'The Grand Inquisitor', artist:'Rupert Friend'},
      {n:'9', name:'Fifth Brother', artist:'Sung Kang'},
      {n:'10', name:'Fourth Sister', artist:'Rya Kihlstedt'},
      {n:'11', name:'Owen Lars', artist:'Joel Edgerton'},
      {n:'12', name:'Beru Lars', artist:'Bonnie Piesse'},
      {n:'13', name:'Haja Estree', artist:'Kumail Nanjiani'},
      {n:'14', name:'Tala Durith', artist:'Indira Varma'},
      {n:'15', name:'Darth Vader', artist:'Hayden Christensen'},
      {n:'16', name:'Bail Organa', artist:'Jimmy Smits'},
      {n:'17', name:'Princess Leia Organa', artist:'Vivien Lyra Blair'},
      {n:'18', name:'NED-B', artist:'Dustin Ceithamer'},
      {n:'19', name:'Jyn Erso', artist:'Felicity Jones'},
      {n:'20', name:'Galen Erso', artist:'Mads Mikkelsen'},
      {n:'21', name:'Han Solo', artist:'Alden Ehrenreich'},
      {n:'22', name:'Qi\'ra', artist:'Emilia Clarke'},
      {n:'23', name:'Chewbacca', artist:'Joonas Suotamo'},
      {n:'24', name:'Maul', artist:'Sam Witwer'},
      {n:'25', name:'Cal Kestis', artist:'Cameron Monaghan'},
      {n:'26', name:'BD-1', artist:'Ben Burtt'},
      {n:'27', name:'Second Sister', artist:'Elizabeth Grullon'},
      {n:'28', name:'Cere Junda', artist:'Debra Wilson'},
      {n:'29', name:'Greez Dritus', artist:'Greez Dritus'},
      {n:'30', name:'Kanan Jarrus', artist:'Freddie Prinze, Jr.'},
      {n:'31', name:'Hera Syndulla', artist:'Vanessa Marshall'},
      {n:'32', name:'Ezra Bridger', artist:'Taylor Gray'},
      {n:'33', name:'Zeb Orrelios', artist:'Steve Blum'},
      {n:'34', name:'Sabine Wren', artist:'Tiya Sircar'},
      {n:'35', name:'Ketsu Onyo', artist:'Gina Torres'},
      {n:'36', name:'Kazuda Xiono', artist:'Christopher Sean'},
      {n:'37', name:'Neeku Vozo', artist:'Josh Brener'},
      {n:'38', name:'Tam Ryvora', artist:'Suzie McGrath'},
      {n:'39', name:'Jarek Yeager', artist:'Scott Lawrence'},
      {n:'40', name:'Synara San', artist:'Nazneen Contractor'},
      {n:'41', name:'Torra Doza', artist:'Myrna Velasco'},
      {n:'42', name:'Bucket', artist:'Justin Ridge'},
      {n:'43', name:'Mace Windu', artist:'Samuel L. Jackson'},
      {n:'44', name:'Count Dooku', artist:'Christopher Lee'},
      {n:'45', name:'Jabba The Hutt', artist:'David Barclay'},
      {n:'46', name:'Salacious B. Crumb', artist:'Mark Dodson'},
      {n:'47', name:'Admiral Ackbar', artist:'Tim Rose'},
      {n:'48', name:'Anakin Skywalker', artist:'Hayden Christensen'},
      {n:'49', name:'Padmé Amidala', artist:'Natalie Portman'},
      {n:'50', name:'Quinlan Vos', artist:'Al Rodrigo'},
      {n:'51', name:'Yoda', artist:'Deep Roy'},
      {n:'52', name:'Han Solo', artist:'Harrison Ford'},
      {n:'53', name:'General Hux', artist:'Domhnall Gleeson'},
      {n:'54', name:'BB-8', artist:'Brian Herring'},
      {n:'55', name:'Maz Kanata', artist:'Lupita Nyong\'o'},
      {n:'56', name:'General Leia Organa', artist:'Carrie Fisher'},
      {n:'57', name:'Supreme Leader Snoke', artist:'Andy Serkis'},
      {n:'58', name:'DJ', artist:'Benicio del Toro'},
      {n:'59', name:'Captain Phasma', artist:'Gwendoline Christie'},
      {n:'60', name:'Qui-Gon Jinn', artist:'Liam Neeson'},
      {n:'61', name:'Jar Jar Binks', artist:'Ahmed Best'},
      {n:'62', name:'Sebulba', artist:'Lewis Macleod'},
      {n:'63', name:'Shmi Skywalker', artist:'Pernilla August'},
      {n:'64', name:'Boss Nass', artist:'Brian Blessed'},
      {n:'65', name:'R2-D2', artist:'Kenny Baker'},
      {n:'66', name:'C-3PO', artist:'Anthony Daniels'},
      {n:'67', name:'Poe Dameron', artist:'Oscar Isaac'},
      {n:'68', name:'Finn', artist:'John Boyega'},
      {n:'69', name:'Rey', artist:'Daisy Ridley'},
      {n:'70', name:'Dark Rey', artist:'Daisy Ridley'},
      {n:'71', name:'Kylo Ren', artist:'Adam Driver'},
      {n:'72', name:'Emperor Palpatine', artist:'Ian McDiarmid'},
      {n:'73', name:'Zorii Bliss', artist:'Keri Russell'},
      {n:'74', name:'Babu Frik', artist:'Shirley Henderson'},
      {n:'75', name:'Klaud', artist:'Nick Kellington'},
      {n:'76', name:'Rose Tico', artist:'Kelly Marie Tran'},
      {n:'77', name:'Lando Calrissian', artist:'Billy Dee Williams'},
      {n:'78', name:'Jannah', artist:'Naomi Ackie'},
      {n:'79', name:'D-O', artist:'Lynn Robertson Bruce'},
      {n:'80', name:'Nien Nunb', artist:'Mike Quinn'},
      {n:'81', name:'Hunter', artist:'Dee Bradley Baker'},
      {n:'82', name:'Wrecker', artist:'Dee Bradley Baker'},
      {n:'83', name:'Tech', artist:'Dee Bradley Baker'},
      {n:'84', name:'Omega', artist:'Michelle Ang'},
      {n:'85', name:'Crosshair', artist:'Dee Bradley Baker'},
      {n:'86', name:'Echo', artist:'Dee Bradley Baker'},
      {n:'87', name:'Luke Skywalker', artist:'Mark Hamill'},
      {n:'88', name:'Krrsantan', artist:'Carey Jones'},
      {n:'89', name:'Boba Fett', artist:'Temuera Morrison'},
      {n:'90', name:'Fennec Shand', artist:'Ming-Na Wen'},
      {n:'91', name:'Cad Bane', artist:'Dorian Kingi'},
      {n:'92', name:'Cobb Vanth', artist:'Timothy Olyphant'},
      {n:'93', name:'Taanti', artist:'W. Earl Brown'},
      {n:'94', name:'Tusken Chief', artist:'Xavier Jimenez'},
      {n:'95', name:'Tusken Warrior', artist:'Joanna Bennet'},
      {n:'96', name:'Ahsoka Tano', artist:'Rosario Dawson'},
      {n:'97', name:'The Mandalorian', artist:'Pedro Pascal'},
      {n:'98', name:'Grogu', artist:'David Acord'},
      {n:'99', name:'Greef Karga', artist:'Carl Weathers'},
      {n:'100', name:'Migs Mayfeld', artist:'Bill Burr'},
    ]
  },
  {
    id: 'first-appearances', type: 'insert',
    title: 'FIRST APPEARANCES SHORT PRINTS — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'FA-1', name:'Darth Vader'},
      {n:'FA-2', name:'Obi-Wan Kenobi'},
      {n:'FA-3', name:'Han Solo'},
      {n:'FA-4', name:'Princess Leia'},
      {n:'FA-5', name:'Luke Skywalker'},
      {n:'FA-6', name:'Darth Maul'},
      {n:'FA-7', name:'Palpatine'},
      {n:'FA-8', name:'The Mandalorian'},
      {n:'FA-9', name:'Grogu'},
      {n:'FA-10', name:'Ahsoka Tano'},
      {n:'FA-11', name:'Queen Amidala'},
      {n:'FA-12', name:'Rey'},
      {n:'FA-13', name:'Finn'},
      {n:'FA-14', name:'Poe Dameron'},
      {n:'FA-15', name:'Kylo Ren'},
      {n:'FA-16', name:'Ezra Bridger'},
      {n:'FA-17', name:'Hera Syndulla'},
      {n:'FA-18', name:'Kanan Jarrus'},
      {n:'FA-19', name:'Jyn Erso'},
      {n:'FA-20', name:'Cassian Andor'},
    ]
  },
  {
    id: 'monikers', type: 'insert', title: 'MONIKERS — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'M-1', name:'Darth Vader'},
      {n:'M-2', name:'Luke Skywalker'},
      {n:'M-3', name:'Rey'},
      {n:'M-4', name:'Chewbacca'},
      {n:'M-5', name:'Han Solo'},
      {n:'M-6', name:'The Mandalorian'},
      {n:'M-7', name:'Grogu'},
      {n:'M-8', name:'Obi-Wan Kenobi'},
      {n:'M-9', name:'Obi-Wan Kenobi'},
      {n:'M-10', name:'R2-D2'},
      {n:'M-11', name:'C-3PO'},
      {n:'M-12', name:'Kylo Ren'},
      {n:'M-13', name:'Anakin Skywalker'},
      {n:'M-14', name:'Ahsoka Tano'},
      {n:'M-15', name:'Sheev Palpatine'},
      {n:'M-16', name:'Leia Organa'},
      {n:'M-17', name:'FN-2187'},
      {n:'M-18', name:'Jabba The Hutt'},
      {n:'M-19', name:'Stormtrooper'},
      {n:'M-20', name:'CT-7567'},
    ]
  },
  {
    id: 'journey-of-grogu', type: 'insert', title: 'JOURNEY OF GROGU — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'JG-1', name:'Jedi Temple Siege'},
      {n:'JG-2', name:'Meeting the Mandalorian'},
      {n:'JG-3', name:'Slaying the Mudhorn'},
      {n:'JG-4', name:'Brought Before the Client'},
      {n:'JG-5', name:'Kidnapped by Toro Calican'},
      {n:'JG-6', name:'Discovered by Mercenaries!'},
      {n:'JG-7', name:'IG-11\'s New Programming'},
      {n:'JG-8', name:'A Clan of Two'},
      {n:'JG-9', name:'The Mysterious Mandalorian of Tatooine'},
      {n:'JG-10', name:'The Mandalorians of Trask'},
      {n:'JG-11', name:'Grogu in Class'},
      {n:'JG-12', name:'Ahsoka Tano Sets Grogu\'s Path'},
      {n:'JG-13', name:'The Seeing Stone'},
      {n:'JG-14', name:'The Dark Troopers Arrive!'},
      {n:'JG-15', name:'Encounter with Moff Gideon'},
      {n:'JG-16', name:'The Mandalorian & His Allies to the Rescue'},
      {n:'JG-17', name:'The future site of Luke Skywalker\'s Jedi Temple'},
      {n:'JG-18', name:'Grogu\'s Choice'},
      {n:'JG-19', name:'Facing the Rancor'},
      {n:'JG-20', name:'The Mandalorian\'s New Ship'},
    ]
  },
  {
    id: 'manga-madness', type: 'insert', title: 'MANGA MADNESS — 15 CARDS',
    parallels: INS_P,
    cards: [
      {n:'MM-1', name:'Leia / Luke / Han / AT-AT'},
      {n:'MM-2', name:'R2-D2 / C-3PO'},
      {n:'MM-3', name:'Darth Vader / Obi-Wan'},
      {n:'MM-4', name:'Darth Vader / Luke'},
      {n:'MM-5', name:'Darth Vader / Luke / Han / Leia'},
      {n:'MM-6', name:'Bounty Hunters'},
      {n:'MM-7', name:'Han / Chewbacca'},
      {n:'MM-8', name:'Cantina'},
      {n:'MM-9', name:'Death Star / Han / Luke / Boba / C-3PO / Jabba'},
      {n:'MM-10', name:'Yoda / Luke / Darth Vader'},
      {n:'MM-11', name:'Han in Carbonite'},
      {n:'MM-12', name:'TIE Fighter / Luke / Darth Vader'},
      {n:'MM-13', name:'Emperor / Millennium Falcon'},
      {n:'MM-14', name:'Princess Leia'},
      {n:'MM-15', name:'Luke Skywalker'},
    ]
  },
  {
    id: 'rotj-40th', type: 'insert',
    title: 'RETURN OF THE JEDI 40TH ANNIVERSARY — 10 CARDS',
    parallels: INS_P,
    cards: [
      {n:'ROJ40-1', name:'R2-D2'},
      {n:'ROJ40-2', name:'Boba Fett'},
      {n:'ROJ40-3', name:'C-3PO'},
      {n:'ROJ40-4', name:'Chewbacca'},
      {n:'ROJ40-5', name:'Han Solo'},
      {n:'ROJ40-6', name:'Yoda'},
      {n:'ROJ40-7', name:'Lando Calrissian'},
      {n:'ROJ40-8', name:'Princess Leia'},
      {n:'ROJ40-9', name:'Luke Skywalker'},
      {n:'ROJ40-10', name:'Darth Vader'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'AUTOGRAPH CARDS — 55 CARDS',
    parallels: AUTO_P,
    cards: [
      {n:'CA-AB', name:'Ahmed Best', artist:'Jar Jar Binks'},
      {n:'CA-ADK', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'CA-AE', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'CA-AS', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'CA-BB', name:'Brian Blessed', artist:'Boss Nass'},
      {n:'CA-BP', name:'Bonnie Piesse', artist:'Beru Lars'},
      {n:'CA-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'CA-CF', name:'Carrie Fisher', artist:'General Leia Organa'},
      {n:'CA-CS', name:'Christopher Sean', artist:'Kazuda Xiono'},
      {n:'CA-CW', name:'Carl Weathers', artist:'Greef Karga'},
      {n:'CA-DB', name:'David Barclay', artist:'Jabba The Hutt'},
      {n:'CA-DC', name:'Dustin Ceithamer', artist:'NED-B'},
      {n:'CA-DG', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'CA-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'CA-DR', name:'Deep Roy', artist:'Yoda'},
      {n:'CA-DRD', name:'Daisy Ridley', artist:'Dark Rey'},
      {n:'CA-DRR', name:'Daisy Ridley', artist:'Rey'},
      {n:'CA-DW', name:'Debra Wilson', artist:'Cere Junda'},
      {n:'CA-EC', name:'Emilia Clarke', artist:'Qi\'ra'},
      {n:'CA-EG', name:'Elizabeth Grullon', artist:'Second Sister'},
      {n:'CA-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'CA-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'CA-FP', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'CA-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'CA-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'CA-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'CA-HCA', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'CA-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'CA-IM', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'CA-IV', name:'Indira Varma', artist:'Tala Durith'},
      {n:'CA-KB', name:'Kenny Baker', artist:'R2-D2'},
      {n:'CA-KT', name:'Kelly Marie Tran', artist:'Rose Tico'},
      {n:'CA-LB', name:'Lynn Robertson Bruce', artist:'D-O'},
      {n:'CA-LM', name:'Lewis Macleod', artist:'Sebulba'},
      {n:'CA-LN', name:'Lupita Nyong\'o', artist:'Maz Kanata'},
      {n:'CA-MD', name:'Mark Dodson', artist:'Salacious B. Crumb'},
      {n:'CA-MI', name:'Moses Ingram', artist:'Reva'},
      {n:'CA-MM', name:'Mads Mikkelsen', artist:'Galen Erso'},
      {n:'CA-MQ', name:'Mike Quinn', artist:'Nien Nunb'},
      {n:'CA-MV', name:'Myrna Velasco', artist:'Torra Doza'},
      {n:'CA-MW', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'CA-NA', name:'Naomi Ackie', artist:'Jannah'},
      {n:'CA-NC', name:'Nazneen Contractor', artist:'Synara San'},
      {n:'CA-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'CA-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'CA-RK', name:'Rya Kihlstedt', artist:'Fourth Sister'},
      {n:'CA-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'CA-SL', name:'Scott Lawrence', artist:'Jarek Yeager'},
      {n:'CA-SM', name:'Suzie McGrath', artist:'Tam Ryvora'},
      {n:'CA-SW', name:'Sam Witwer', artist:'Maul'},
      {n:'CA-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'CA-TR', name:'Tim Rose', artist:'Admiral Ackbar'},
      {n:'CA-VB', name:'Vivien Lyra Blair', artist:'Princess Leia Organa'},
      {n:'CA-VM', name:'Vanessa Marshall', artist:'Hera Syndulla'},
      {n:'CA-XJ', name:'Xavier Jimenez', artist:'Tusken Chief'},
    ]
  },
  {
    id: 'first-appearance-autos', type: 'auto',
    title: 'FIRST APPEARANCES AUTOGRAPHS — 10 CARDS',
    parallels: RED_SUPER_P,
    cards: [
      {n:'FAA-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'FAA-CF', name:'Carrie Fisher', artist:'Princess Leia Organa'},
      {n:'FAA-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'FAA-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'FAA-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'FAA-FP', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'FAA-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'FAA-IM', name:'Ian McDiarmid', artist:'Palpatine'},
      {n:'FAA-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'FAA-VM', name:'Vanessa Marshall', artist:'Hera Syndulla'},
    ]
  },
  {
    id: 'auto-dual', type: 'auto', title: 'DUAL AUTOGRAPHS — 8 CARDS',
    parallels: RED_SUPER_P,
    cards: [
      {n:'DA-CE', name:'Emilia Clarke / Alden Ehrenreich', artist:'Qi\'ra / Han Solo'},
      {n:'DA-CT', name:'Hermione Corfield / Kelly Marie Tran', artist:'Tallie Lintra / Rose Tico'},
      {n:'DA-LW2', name:'Diego Luna / Forest Whitaker', artist:'Cassian Andor / Saw Gerrera'},
      {n:'DA-MC', name:'Hayden Christensen / Ewan McGregor', artist:'Darth Vader / Obi-Wan Kenobi'},
      {n:'DA-PM', name:'Natalie Portman / Ian McDiarmid', artist:'Padmé Amidala / Chancellor Palpatine'},
      {n:'DA-SR', name:'Kiran Shah / Daisy Ridley', artist:'Nambi Ghima / Rey'},
      {n:'DA-TL', name:'Billie Lourd / Kelly Marie Tran', artist:'Kaydel Ko Connix / Rose Tico'},
      {n:'DA-WC', name:'Sam Witwer / Emilia Clarke', artist:'Maul / Qi\'ra'},
    ]
  },
  {
    id: 'auto-triple', type: 'auto', title: 'TRIPLE AUTOGRAPHS — 4 CARDS',
    parallels: RED_SUPER_P,
    cards: [
      {n:'TA-BMP', name:'Matt Berry / David Pasquesi / Temuera Morrison', artist:'8D8 / Twi\'lek Majordomo / Boba Fett'},
      {n:'TA-EKC', name:'Emilia Clarke / Alden Ehrenreich / Erin Kellyman', artist:'Qi\'ra / Han Solo / Enfys Nest'},
      {n:'TA-JML', name:'Diego Luna / Felicity Jones / Mads Mikkelsen', artist:'Cassian Andor / Jyn Erso / Galen Erso'},
      {n:'TA-SFD', name:'Adam Driver / Andy Serkis / Harrison Ford', artist:'Kylo Ren / Supreme Leader Snoke / Han Solo'},
    ]
  },
  {
    id: 'sketch', type: 'sketch', title: 'SKETCH CARDS',
    parallels: [],
    cards: [
      {n:'SK-1', name:'Sketch Card', artist:'Various Artists'},
      {n:'SK-2', name:'Manga Sketch Card', artist:'Various Artists'},
    ]
  },
];

export const PARALLELS = BASE_P;
export const AUTO_PARALLELS = AUTO_P;
export const INSERT_PARALLELS = INS_P;
